import { z } from 'zod';
import { legalClientSchema } from './ILegalClient';

// Zod-Schema für ISendDocumentDocumentType (englische Werte)
export const ISendDocumentDocumentTypeSchema = z.enum([
  'Record',
  'Invoice',
  'Drafts',
  'DocumentsFromRequirements',
  'EmailsFromRequirements',
  'SideFile',
]);

// Zod-Schema für ISendDocumentSendOption (englische Werte)
export const ISendDocumentSendOptionSchema = z.enum([
  'Email',
  'Documentportal',
]);

/**
 * Einheitliches Auswahlmodell:
 * - Frontend arbeitet intern mit selectedDocuments (IDocument[])
 * - Payload an Backend: selectedDocumentIds: number[]
 * - selectedDocuments bleibt nur als Rückwärtskompatibilität / Debug-Feld optional erhalten
 */
export const ISendDocumentNewSchema = z.object({
  legalClientArray: z.array(legalClientSchema).default([]),
  documentTypeArray: z.array(ISendDocumentDocumentTypeSchema).default([]),
  emailText: z.string().optional().default(''),
  subject: z.string().default(''),
  sendOption: ISendDocumentSendOptionSchema.default('Documentportal'),
  idLegalTransaction: z.number(),

  // NEU: das ist das Feld, das das Backend primär verarbeitet
  selectedDocumentIds: z.array(z.number().int().positive()).default([]),

  // ALT/optional: Übergang, falls irgendwo noch Objekte geschickt werden.
  // Backend kann weiterhin daraus IDs extrahieren, wenn selectedDocumentIds fehlt.
  selectedDocuments: z.array(z.any()).optional().default([]),
});

export const SendOption = {
  Email: 'Email',
  Documentportal: 'Documentportal',
} as const;

export type ISendDocumentNewSendOption = keyof typeof SendOption;

export type ISendDocumentNew = z.infer<typeof ISendDocumentNewSchema>;

export const initSendDocumentNew = (
  legalTransactionId: number
): ISendDocumentNew =>
  ISendDocumentNewSchema.parse({ idLegalTransaction: legalTransactionId });
